import { Text } from '@eo-locale/react';
import { FC } from 'react';
import { InnerPageSection, InnerPageTitle, Table } from '../components';
import { useUserMembership } from '../hooks';
import { useQuery } from 'react-query';
import { UserApi } from '../api';

export const MembershipPage: FC = () => {
  const { groups } = useUserMembership();
  const { data } = useQuery('user', UserApi.fetch);

  return (
    <>
      {groups.map((group, index) => {
        if (group.list.length === 0) {
          return null;
        }

        return (
          <InnerPageSection key={`group-${index}`}>
            <InnerPageTitle>
              <Text id={group.title} />
            </InnerPageTitle>
            <Table>
              <thead>
                <tr>
                  <th>
                    <Text id="membership:title" />
                  </th>
                  <th>
                    <Text id="membership:date_start" />
                  </th>
                  <th>
                    <Text id="membership:last_change" />
                  </th>
                </tr>
              </thead>
              <tbody>
                {group.list.map((membership, index) => {
                  return <tr key={index}>
                    <td>{membership.name}</td>
                    <td>{data?.accession_year}</td>
                    <td>{membership.updated_at}</td>
                  </tr>
                })}
              </tbody>
            </Table>
          </InnerPageSection>
        );
      })}
    </>
  );
};
